import React from 'react';
import styled from 'styled-components';
import {
    ICON_STATUS,
    useInformation,
} from 'components/customer/JobDashboard/helpers/useInformation';
import {HardwareOptionImage} from 'components/customer/JobDashboard/columns/HardwareOptionImage';
import {Product} from 'components/customer/Product/entity/Product';

interface InformationProps {
    product: Product;
}

export const Information = ({product}: InformationProps) => {
    const {
        isLoading,
        productSupplyMethods,
        hardwareInclusions,
        adjustableLegs,
        showSupplyMethods,
        showHardwareInclusions,
        showAdjustableLegs,
    } = useInformation(product?.type);

    return (
        <Container>
            {showSupplyMethods === ICON_STATUS.SHOW ? (
                <HardwareOptionImage
                    options={productSupplyMethods}
                    value={product.include_assembly}
                    type="assembly"
                    loading={isLoading}
                />
            ) : null}
            {showHardwareInclusions === ICON_STATUS.SHOW ? (
                <HardwareOptionImage
                    options={hardwareInclusions}
                    value={product.exclude_hardware ? 0 : 1}
                    type="hardware"
                    loading={isLoading}
                />
            ) : null}
            {showAdjustableLegs === ICON_STATUS.SHOW ? (
                <HardwareOptionImage
                    options={adjustableLegs}
                    value={product.cabinet_adjustable_legs}
                    type="legs"
                    loading={isLoading}
                />
            ) : null}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;
